import React, { useState, useMemo } from "react";
import { Typography } from "@mhome/ui";
import TimeGeneralInput from "../input/time-general-input";

const TimeGeneralCell = ({
  value,
  onChange,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  ...cellProps
}) => {
  const [editValue, setEditValue] = useState(value || "12:00:00");

  const handleCellClick = () => {
    if (!isEditing) {
      setEditValue(value || "12:00:00");
      onEdit();
    }
  };

  const handleSave = () => {
    onChange(editValue);
    onSave();
  };

  const handleCancel = () => {
    setEditValue(value || "12:00:00");
    onCancel();
  };

  const handleTimeChange = (newValue) => {
    setEditValue(newValue);
    // Auto-save when time value changes (when user clicks Save in TimeGeneralInput dialog)
    onChange(newValue);
    onSave();
  };

  // Convert MUI spacing to pixels (MUI spacing unit = 8px)
  const spacingToPx = (spacing) =>
    typeof spacing === "number" ? spacing * 8 : spacing;

  const cellStyle = useMemo(
    () => ({
      cursor: "pointer",
      padding: "4px",
      border: isEditing ? `2px solid hsl(var(--primary))` : "none",
      borderRadius: isEditing ? spacingToPx(1) : 0, // 8px
      width: "100%",
      height: "40px",
      display: "flex",
      alignItems: "center",
    }),
    [isEditing]
  );

  return (
    <div
      style={cellStyle}
      onClick={handleCellClick}
      onMouseEnter={(e) => {
        if (!isEditing) {
          e.currentTarget.style.backgroundColor = "hsl(var(--accent))";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "transparent";
      }}
    >
      {isEditing ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <TimeGeneralInput
            valueSpec={{
              value: editValue,
              readOnly: false,
            }}
            onChange={handleTimeChange}
            zIndex={1400}
          />
        </div>
      ) : (
        <Typography
          variant="body2"
          style={{
            paddingLeft: spacingToPx(1),
            paddingRight: spacingToPx(1),
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {value || "12:00:00"}
        </Typography>
      )}
    </div>
  );
};

export default TimeGeneralCell;
